import type { SVGProps } from "react";

export function IconWhiteFlag(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.7501 8C53.7501 6.75736 54.7575 5.75 56.0001 5.75C57.2427 5.75 58.2501 6.75736 58.2501 8C58.2501 9.24264 57.2427 10.25 56.0001 10.25C54.7575 10.25 53.7501 9.24264 53.7501 8ZM56.0001 4.25C53.929 4.25 52.2501 5.92893 52.2501 8C52.2501 9.35536 52.9691 10.5428 54.0466 11.2016L54.0291 11.25H6.05567L22.805 26.4291L2.64966 40.75H43.2944L36.6318 58.4018L36.5318 58.6667H38.1351L55.4574 11.711C55.6346 11.7367 55.8158 11.75 56.0001 11.75C58.0712 11.75 59.7501 10.0711 59.7501 8C59.7501 5.92893 58.0712 4.25 56.0001 4.25ZM9.94458 12.75H53.4874L43.8606 39.25H7.35052L25.1952 26.5709L9.94458 12.75Z"
        fill="#23232C"
      />
    </svg>
  );
}
